import { API_URL } from "../../config/connect";

/**
 * Fetch regions from the Location API
 * @param {number} countryId - Optional country ID to filter regions
 * @returns {Promise<Array>} Array of regions
 */
export async function getRegions(countryId = null) {
    let endpoint = `${API_URL}/api/v1/regions`;
    
    if (countryId) {
        endpoint += `?country_id=${countryId}`;
    }

    try {
        const response = await fetch(endpoint, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.statusText}`);
        }

        const result = await response.json();
        return result.regions || [];
    } catch (error) {
        console.error('Failed to fetch regions:', error);
        throw error;
    }
}

